export default "__VITE_ASSET__Bk7pe__n__"